<style>
  .UnSubmit {
    background-color: #ff9595 !important;
  }
</style>

<div class="col-md-12 mb-30" style="margin-top: 20px;">
  <div class="card card-statistics h-100" [hidden]="DataList_Kartable_Selected_DeviceBehfa.id>0" >
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">کنترل گواهی نامه های صادر شده</h5>

      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">بازه زمانی</label>
          <select class="custom-select" [(ngModel)]="SubmitPeriodDate" name="SubmitPeriodDate">
            <option value="1">اعمال شود</option>
            <option value="0">اعمال نشود</option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">تاریخ شروع</label>
          <input type="text" #datepickerInputStart placeholder="اینجا تایپ کنید ..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">تاریخ پایان</label>
          <input type="text" #datepickerInputEnd placeholder="اینجا تایپ کنید ..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd"></ng-persian-datepicker>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">شماره گواهی</label>
          <input [(ngModel)]="Filter_Certificate_User" (keyup.enter)="ReadData_Kartable(datepickerInputStart.value,datepickerInputEnd.value)" (keyup)="Change_Filter_Order()"
            name="Filter_Certificate_User" type="text" class="form-control"
            placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">نام مشتری</label>
          <input [(ngModel)]="Filter_Customer_Order" (keyup.enter)="ReadData_Kartable(datepickerInputStart.value,datepickerInputEnd.value)" (keyup)="Change_Filter_Order()"
            name="Filter_Customer_Order" type="text" class="form-control"
            placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
         <div class="form-group col-md-4">
          <label for="exampleInputEmail1">نام کارشناس</label>
          <input [(ngModel)]="Filter_Expert_Name_Order" (keyup.enter)="ReadData_Kartable(datepickerInputStart.value,datepickerInputEnd.value)" (keyup)="Change_Filter_Order()"
            name="Filter_Expert_Name_Order" type="text" class="form-control"
            placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">شماره رسید</label>
          <input [(ngModel)]="Filter_RecieveCode_Order" (keyup.enter)="ReadData_Kartable(datepickerInputStart.value,datepickerInputEnd.value)" (keyup)="Change_Filter_Order()"
            name="Filter_RecieveCode_Order" type="text" class="form-control"
            placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">شماره نامه</label>
          <input [(ngModel)]="Filter_Code2_Order" (keyup.enter)="ReadData_Kartable(datepickerInputStart.value,datepickerInputEnd.value)" (keyup)="Change_Filter_Order()"
            name="Filter_Code2_Order" type="text" class="form-control"
            placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">نام لاتین دستگاه</label>
          <input [(ngModel)]="Filter_Devicename_Order" (keyup.enter)="ReadData_Kartable(datepickerInputStart.value,datepickerInputEnd.value)" (keyup)="Change_Filter_Order()"
            name="Filter_Devicename_Order" type="text" class="form-control"
            placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-6">
          <button *ngIf="!Procssing_Kartable" type="button"
            (click)="ReadData_Kartable(datepickerInputStart.value,datepickerInputEnd.value)"
            class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات
          </button>
          <img *ngIf="Procssing_Kartable" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 mb-30" *ngFor="let item of DataList_Kartable
        |filter:Filter_Customer_Order:'customer'
        |filter:Filter_RecieveCode_Order:'recieveCode'
        |filter:Filter_Code2_Order:'code2'
        |filter:Filter_Devicename_Order:'devicename'
        |filter:Filter_Expert_Name_Order:'expert_name'
        |filter:Filter_Certificate_User:'certificate_user_code'
        | paginate
                : {
                    id: 'DataList_Kartable',
                    itemsPerPage: 20,
                    currentPage: page_Kartable,
                    totalItems: (DataList_Kartable
                    |filter:Filter_Customer_Order:'customer'
                    |filter:Filter_RecieveCode_Order:'recieveCode'
                    |filter:Filter_Code2_Order:'code2'
                    |filter:Filter_Devicename_Order:'devicename'
                    |filter:Filter_Expert_Name_Order:'expert_name'
                    |filter:Filter_Certificate_User:'certificate_user_code'
                    ).length
                  }
        ">

          <div class="card h-100" [ngClass]="{'UnSubmit': item.controller.length>0}">
            <div class="card-body">
              <div style="float: right;">
                <p><span  style="font-weight: 600;">دستگاه</span>  '{{item.devicename}}' </p>
              </div>
              <div style="float: left;">
                <p>
                  <span  style="font-weight: 600;">شماره نامه	</span> '{{item.code2}}'

                </p>
              </div>
              <div style="clear: both;"></div>
              <p>
                <span  style="font-weight: 600;">نام مشتری	</span>
                 '{{item.customer}} ({{item.customer_code}})'
                 <span *ngIf="!item.expert_submit_date_visible" style="font-weight: 600;color: #031dd5;"> (جدید) </span>
              </p>
              <p>
                <span  style="font-weight: 600;"> شماره گواهی </span>
                 '{{item.certificate_user_code}}'

              </p>

              <hr/>
              <div style="float: right;">
                <p><span  style="font-weight: 600;">کد دستگاه </span> '{{item.code}}' </p>
                <p><span  style="font-weight: 600;">سریال دستگاه</span> '{{item.serial}}' </p>
                <p><span  style="font-weight: 600;">شماره رسید</span> '{{item.recieveCode}}' </p>
                <p>
                  <span  style="font-weight: 600;">محل </span>
                  <span *ngIf="item.inlocation">در محل مشتری</span>
                  <span *ngIf="!item.inlocation">در محل آزمایشگاه</span>
                </p>
              </div>
              <div style="float: left;">
                <p><span  style="font-weight: 600;">کارشناس</span> '{{item.expert_name}}' </p>
                <p><span  style="font-weight: 600;">وضعیت</span>  '{{item.status}}' </p>
                <p><span  style="font-weight: 600;">تاریخ تحویل	</span>  '{{item.tarikhTahvi}}' </p>
                <p><span  style="font-weight: 600;">تاریخ تایید	</span>  '{{item.expertSubmitDate}}' </p>
              </div>
              <div style="clear: both;"></div>

              <hr/>

              <span  *ngIf="item.flowchartRequestDsc">
                <p><span  style="font-weight: 600;">بازیابی گواهی نامه</span>  '{{item.flowchartRequestDsc}}' </p>
                <hr/>
              </span>   

              <p><span  style="font-weight: 600;">توضیحات تعرفه</span>  '{{item.tariff_dsc}}' </p>

              <hr/>


              <img *ngIf="item.Processing" src="assets/Loading.gif" style="width: 25px;" />



              <div *ngIf="!item.Processing">


                <div class="row">
                  <a  *ngIf="item.filename && !item.filename.toLowerCase().includes('certificates')"(click)="SetCalibrationDetailVisible(item)" target="_blank" href="{{BaseUrl}}File/Calibration/{{item.filename}}" class="btn btn-info"><i class="fa fa-eye"></i> فایل گواهی نامه </a>
                  <a  *ngIf="item.filename && item.filename.toLowerCase().includes('certificates')"(click)="SetCalibrationDetailVisible(item)" target="_blank" href="{{LabUrl}}{{item.filename}}" class="btn btn-info"><i class="fa fa-eye"></i> فایل گواهی نامه </a>
                  <a  *ngIf="item.certificate && !item.filename" (click)="SetCalibrationDetailVisible(item)" target="_blank" href="{{BaseUrl}}{{item.certificate}}" class="btn btn-info"><i class="fa fa-eye"></i> فایل گواهی نامه </a>

                  <button type="button" style="margin-right: 10px;" (click)="OnSet_Calibration_DeviceBehfa(item)"  class="btn btn-warning"> <i class="fa fa-building"></i> تجهیز بهفا
                  </button>

                  <button type="button" *ngIf="item.expert_submit_date_visible" (click)="openModal(template,item,1)" style="margin-right: 10px;"  class="btn btn-success"> <i class="fa fa-check"></i> تایید
                  </button>

                  <button type="button" *ngIf="item.expert_submit_date_visible" (click)="openModal(template,item,-1)" style="margin-right: 10px;" class="btn btn-danger"> <i class="fa fa-times"></i> عدم تایید
                  </button>

                  <button type="button" *ngIf="item.controller.length>0" (click)="openModal_Controller(templateController,item)" style="margin-right: 10px;" class="btn btn-danger"><i
                      class="fa fa-file"></i> پیام های کنترل کننده </button>

                </div>
              </div>



            </div>
          </div>
        </div>

      </div>

      <pagination-controls id="DataList_Kartable" nextLabel="بعدی" previousLabel="قبلی"
        (pageChange)="page_Kartable = $event"></pagination-controls>


    </div>
  </div>

  <app-CalibrationDeviceBehfa *ngIf="DataList_Kartable_Selected_DeviceBehfa.id>0"
    (OnBack_CalibrationDeviceBehfa_Action)="OnSet_Back_Calibration_DeviceBehfa($event)"
    [inner_Kartable_Order_Interface]="DataList_Kartable_Selected_DeviceBehfa"
    [inner_Can_Add_Edit]="false"
    [inner_Persian_Date]="PersianToDayDate">

  </app-CalibrationDeviceBehfa>

</div>


<ng-template #template>
  <div class="modal-header">
    <h4 *ngIf="Data_Seleted_Delete_Status==-1" class="modal-title pull-left"> عدم تایید گواهی نامه دستگاه '{{DataList_Kartable_Selected.devicename}}' </h4>
    <h4 *ngIf="Data_Seleted_Delete_Status==1" class="modal-title pull-left">  تایید گواهی نامه دستگاه '{{DataList_Kartable_Selected.devicename}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body" *ngIf="Data_Seleted_Delete_Status==-1">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">توضیحات</label>
        <input [(ngModel)]="OperationDsc" (keyup.enter)="SubmitController()"  name="OperationDsc" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button *ngIf="Data_Seleted_Delete_Status==-1" type="button" class="btn btn-danger" (click)="SubmitController()"> عدم تایید <i class="fa fa-times-rectangle"></i></button>
    <button *ngIf="Data_Seleted_Delete_Status==1" type="button" class="btn btn-success" (click)="SubmitController()"> تایید <i class="fa fa-check"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateController>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> پیام های کنترل کننده '{{Selected_DataList_Calibration.devicename}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Controller.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>توضیحات</th>
              <th>کاربر</th>
              <th>تاریخ</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of Controller_Data_List">
              <td>{{Controller_Data_List.indexOf(item)+1}}</td>
              <td>{{item.dsc}}</td>
              <td>{{item.title}}</td>
              <td>{{item.code}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modalRef_Controller.hide()">بستن</button>
  </div>
</ng-template>
